import React, { useEffect, useState, useRef } from "react";
import WishModal from "../../global/SendWishModal";
import { recentEmployees } from "../../../api/ApiConfig";
import "./EmployeeOnBoard.css";
import { IoIosSend } from "react-icons/io";
import { FaUserPlus } from "react-icons/fa";

export default function EmployeeOnBoard() {
  const [showWishModal, setShowWishModal] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeEmail, setSelectedEmployeeEmail] = useState("");
  const scrollRef = useRef(null);

  const handleOpenModal = (id) => {
    setSelectedEmployeeEmail(id);
    setShowWishModal(true);
  };

  const handleCloseModal = () => {
    setSelectedEmployeeEmail("");
    setShowWishModal(false);
  };

  const handleSend = () => {
    handleCloseModal();
  };

  const getRandomColor = () => {
    const colors = [
      { bg: "#EDE9FE", text: "#5B21B6" },
      { bg: "#D1FAE5", text: "#065F46" },
      { bg: "#FEF3C7", text: "#92400E" },
      { bg: "#FCE7F3", text: "#9F1239" },
      { bg: "#DBEAFE", text: "#1E40AF" },
      { bg: "#E0E7FF", text: "#3730A3" },
      { bg: "#FEE2E2", text: "#991B1B" },
    ];
    const c = colors[Math.floor(Math.random() * colors.length)];
    return { bgColor: c.bg, textColor: c.text };
  };

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await recentEmployees();
        if (res?.data) {
          setEmployees(res.data.map((emp) => ({ ...emp, ...getRandomColor() })));
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let paused = false;
    const onEnter = () => (paused = true);
    const onLeave = () => (paused = false);

    el.addEventListener("mouseenter", onEnter);
    el.addEventListener("mouseleave", onLeave);

    const id = setInterval(() => {
      if (paused || !el) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        el.scrollTop = 0;
      } else {
        el.scrollTop += 1;
      }
    }, 50);

    return () => {
      clearInterval(id);
      el.removeEventListener("mouseenter", onEnter);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, [employees]);

  return (
    <>
      <div className="onboard-wrapper">

        {/* ── Header ── */}
        <div className="onboard-header">
          <div className="header-top">
            <h2 className="onboard-title">Welcome Onboard</h2>

          </div>
          <p className="onboard-subtitle">Recent joiners</p>
        </div>

        {/* ── Divider ── */}
        <div className="header-rule" />

        {/* ── List ── */}
        <div className="onboard-list" ref={scrollRef}>
          {employees.length === 0 ? (
            <div className="empty-state">
              <span className="empty-icon-bg">
                <FaUserPlus />
              </span>
              <p className="empty-title">No new joiners yet</p>
              <p className="empty-hint">Recently hired employees will appear here</p>
            </div>
          ) : (
            employees.map((emp, i) => (
              <div className="emp-row" key={i}>

                {/* Avatar with gradient ring */}
                <div className="avatar-ring">
                  <div className="avatar-inner">
                    {emp.photo?.trim() ? (
                      <img
                        src={emp.photo}
                        alt={emp.name}
                        className="emp-img"
                        key={emp.photo}
                      />
                    ) : (
                      <div
                        className="emp-initials"
                        style={{ background: emp.bgColor, color: emp.textColor }}
                      >
                        {getInitials(emp.name)}
                      </div>
                    )}
                  </div>
                  <span className="status-dot" aria-label="Online" />
                </div>

                {/* Name & Role */}
                <div className="emp-info">
                  <span className="emp-name">{emp.name}</span>
                  <span className="emp-role">{emp.designation}</span>
                </div>

                {/* Send Wishes */}
                <button
                  className="wish-btn"
                  onClick={() => handleOpenModal(emp.emp_id)}
                  aria-label={`Send wishes to ${emp.name}`}
                  title={`Send wishes to ${emp.name}`}
                >
                  <IoIosSend className="wish-icon" />
                </button>

              </div>
            ))
          )}
        </div>

      </div>

      <WishModal
        show={showWishModal}
        handleClose={handleCloseModal}
        onSend={handleSend}
        recipientEmail={selectedEmployeeEmail}
      />
    </>
  );
}